// extracted by mini-css-extract-plugin
export var errorIcon = "_i7-1";
export var nameLogo = "_i7-0";